/**
 * @title job_application.tsx
 *
 * @fileoverview Helper methods for job applications.
 */

import { Job } from '~/jobiqo/types/types';

/**
 * Checks if a user can apply for a job.
 */
export const jobCanApplyTo = (job: Job) => {
  return job.workflowState.value === 'published' && !(job as any)?.isCipher;
};

export const jobIsQuickApply = (job: Job) => {
  return job.applicationWorkflow === 'quick';
};
